import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import { getCommonFieldBasedElementParams, useDatasheetElementController } from "@modules/datasheets/components/result/controllers/datasheet-element";
import { stringHasInteger } from "@common/utils/string";

export type NumberFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useNumberFieldController = (props: NumberFieldProps) => {
  const { datasheetElement, onChange } = props;
  const [fieldValue, setFieldValue] = React.useState(datasheetElement.original.field.fieldname);

  React.useEffect(() => {
    if (fieldValue !== datasheetElement.original.field.fieldname) {
      setFieldValue(datasheetElement.original.field.fieldname);
    }
  }, [datasheetElement.original.field.fieldname]);

  const { 
    headingSizeDependencies, 
    headingPlacedHorizontally, 
    headingPosition 
  } = getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(
    props,
    { headingSizeDependencies }
  );

  const handleFieldValueChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (stringHasInteger(e.target.value)) {
      setFieldValue(e.target.value);
    }
  }, []);

  const handleFieldValueSave = React.useCallback(() => {
    onChange(datasheetElement.id, {
      ...datasheetElement,
      original: {
        ...datasheetElement.original,
        field: {
          ...datasheetElement.original.field,
          name: fieldValue,
        },
      },
    });
  }, [onChange, fieldValue, datasheetElement]);

  return {
    handleFieldValueSave,
    handleFieldValueChange,
    headingPosition,
    headingPlacedHorizontally,
    fieldValue,
    ...baseDatasheetElementController,
  };
};